import { BaseItem, NullablePartial } from '../common';
import { Timing, UpsertTiming } from './timing';

interface BaseSchedule {
  name: string;
  deletedTimestamp: Date | null;
  organizationId: string | null;
}
interface BaseScheduleWithTimings extends BaseSchedule {
  timings: Timing[];
}

export interface Schedule extends BaseItem, BaseSchedule {}

export interface ScheduleListEntry extends Schedule {
  messageCount: number;
  relativeTime: 'After Intake Created' | 'Before Start Time';
}

export interface ScheduleWithTimings
  extends BaseItem,
    BaseScheduleWithTimings {}

export type CreateValues = NullablePartial<
  Omit<BaseScheduleWithTimings, 'deletedTimestamp' | 'timings'>
> & { timings: UpsertTiming[] };

export type UpdateValues = Partial<
  Omit<BaseScheduleWithTimings, 'timings'> & {
    timings: UpsertTiming[];
  }
>;

export interface CloneValues {
  newName: string;
}
export interface CloneResponse {
  id: string;
}

export type FindAllOptions = Partial<{
  q: string;
  name: string;
  organizationIds: string[];
  includeDeleted: boolean;
}>;

export * from './timing';
export * from './timing/rule';
